<template>
   <footer class="footer">
     <div class="container">
       <div class="content has-text-centered">
         <p><a v-on:click="showPolicyModalView">Política de Devolução</a> | <a v-on:click="showPaymentsModalView">Pagamentos</a> | <a href="https://www.neolivros.com/static/termos-condicoes.pdf">Termos e Condições</a> | <a v-on:click="showContactsModalView">Contactos</a></p>
         <p>
           (c) <strong>Neolivros</strong> 2001-2018
         </p>
         <p>
           <a class="icon" href="https://twitter.com/neolivros">
             <i class="fa fa-twitter"></i>
           </a>
           <a class="icon" href="https://www.facebook.com/neolivros">
             <i class="fa fa-facebook"></i>
           </a>
         </p>
         <!-- PayPal Logo -->
         <p class="paypal has-text-centered">
         <a href="https://www.paypal.com/webapps/mpp/paypal-popup" title="How PayPal Works" onclick="javascript:window.open('https://www.paypal.com/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg" border="0" alt="PayPal Acceptance Mark"></a>
         </p>
         <!-- PayPal Logo -->
       </div>
     </div>

     <div id="modal-contacts" class="modal modal-view-contacts">
       <div class="modal-background"></div>
       <div class="modal-card">
         <header class="modal-card-head">
           <p class="modal-card-title">Contactos</p>
           <button v-on:click="hideContactsModalView" class="delete" aria-label="close"></button>
         </header>
         <section class="modal-card-body">
           <p><b>NEOLIVROS</b><br><i class="fa fa-address-card" aria-hidden="true"></i> Rua da Figueira da Foz, 39<br>3000-209 Coimbra</p>
           <br>
           <p><i class="fa fa-envelope" aria-hidden="true"></i> info@neolivros.com</p>
           <br>
           <p><i class="fa fa-phone-square" aria-hidden="true"></i> 239093192</p>
         </section>
         <footer class="modal-card-foot">
         </footer>
       </div>
     </div>

     <div id="modal-policy" class="modal modal-view-policy">
       <div class="modal-background"></div>
       <div class="modal-card">
         <header class="modal-card-head">
           <p class="modal-card-title">Política de reembolso</p>
           <button v-on:click="hidePolicyModalView" class="delete" aria-label="close"></button>
         </header>
         <section class="modal-card-body">
<p><strong>Trocas e devoluções</strong></p>
<p>A Neolivros permite a troca ou devolução de artigos, no prazo de 30 dias a contar da data da sua recepção pelo cliente. Ultrapassados os 30 dias após a data de recepção não é possível solicitar reembolso ou troca de produtos.</p>
<p>Para poder efectuar a devolução, o produto não pode ter sido usado e deve estar nas mesmas condições que o recebeu e na embalagem original.
<p>Para efectuar a devolução, o cliente deve apresentar o comprovativo de compra.
<p>Em certos casos, poderão ser emitidos apenas reembolsos parciais:</p>
<li>Livros com sinais óbvios de uso</li>
<li>Qualquer produto que não esteja em sua condição original, que esteja danificado ou com partes em falta, não sendo tal dano imputável à Neolivros.</li>
<li>Qualquer produto que for devolvido num prazo superior a 30 dias após a entrega.</li>
<br>
<p><strong>Reembolsos</strong></p>
<p>Uma vez recebido e verificado o produto a devolver, enviaremos um e-mail para a notificar o cliente que recebemos a mercadoria para devolução. Iremos igualmente notificá-lo sobre a aprovação ou rejeição do seu reembolso.
<p>Caso seja aprovado, o reembolso será processado e emitiremos o crédito automaticamente no cartão de crédito do cliente ou outro método de pagamento da compra.
<p><strong>Reembolso atrasado ou não recebido</strong>
<p>Caso ainda não tenha recebido um reembolso, o cliente deve verificar a sua conta bancária ou entrar em contacto com a empresa de cartão de crédito. Caso ainda não tenha recebido o reembolso, por favor, deverá entrar em contacto connosco através do endereço info@neolivros.com.
<p><strong>Trocas (quando aplicável)</strong>
<p>Só trocamos produtos que vierem com defeito ou danificados. Caso o cliente pretenda trocá-lo pelo mesmo produto, devera enviar um e-mail para o info@neolivros.com.
<p><strong>Devolução</strong>
<p>Para fazer a devolução do produto deverá entrar em contacto através de um dos meios disponíveis no nosso portal www.neolivros.com.
<p>O cliente é responsável pelo pagamento dos portes decorrentes da devolução do produto. Não reembolsamos os custos de envio.</p>
         </section>
         <footer class="modal-card-foot">
         </footer>
       </div>
     </div>

     <div id="modal-payments" class="modal modal-view-payments">
       <div class="modal-background"></div>
       <div class="modal-card">
         <header class="modal-card-head">
           <p class="modal-card-title">Meios de pagamento</p>
           <button v-on:click="hidePaymentsModalView" class="delete" aria-label="close"></button>
         </header>
         <section class="modal-card-body">
<p><strong>PayPal</strong></p>
<p>Ao seleccionar este método de pagamento será redireccionado para o site da PayPal, onde deverá introduzir as suas credenciais de acesso PayPal para concluir a encomenda.
<p>Note que a sua encomenda será enviada para o endereço registado com a Paypal.</p>
<p class="paypal has-text-centered">
<a href="https://www.paypal.com/webapps/mpp/paypal-popup" title="How PayPal Works" onclick="javascript:window.open('https://www.paypal.com/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg" border="0" alt="PayPal Acceptance Mark"></a>
</p>
         </section>
         <footer class="modal-card-foot">
         </footer>
       </div>
     </div>

   </footer>
</template>

<script>
import { categoriesRef } from '../firebase_config'
export default {
  name: 'foot',
  methods: {
    showContactsModalView: function (event) {
      document.querySelector('.modal-view-contacts').classList.toggle('is-active')
    },
    hideContactsModalView: function (event) {
      document.querySelector('.modal-view-contacts').classList.toggle('is-active')
    },
    showPolicyModalView: function (event) {
      document.querySelector('.modal-view-policy').classList.toggle('is-active')
    },
    hidePolicyModalView: function (event) {
      document.querySelector('.modal-view-policy').classList.toggle('is-active')
    },
    showPaymentsModalView: function (event) {
      document.querySelector('.modal-view-payments').classList.toggle('is-active')
    },
    hidePaymentsModalView: function (event) {
      document.querySelector('.modal-view-payments').classList.toggle('is-active')
    }
  },
  // mounted: function () {
  // },
  firebase: {
    categories: {
      source: categoriesRef,
      asObject: false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-body p {
  margin-bottom: 1.1rem;
}
.paypal img {
  width:180px;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue